import { render, staticRenderFns } from "./MenuProducts.vue?vue&type=template&id=47e105c0&"
import script from "./MenuProducts.vue?vue&type=script&lang=js&"
export * from "./MenuProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports